import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useState } from "react";
import { $createParagraphNode, $getRoot, $getSelection, $isRangeSelection } from "lexical";
import { useValidationService } from "../../../../../services/hooks/index.js";
import { Dialog, DialogContent } from "../../../../../Dialog/index.js";
import { Button } from "../../../../../Button/index.js";
import { TextInput } from "../../../../index.js";
import { $createQuoteNode } from "../../../nodes/QuoteNode/index.js";
import { useForm } from "../../hooks/index.js";
import { getSelectedNode } from "../../../utils/index.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
const QuoteDialog = (t0)=>{
    const $ = c(47);
    const { editor, open, onClose, selectionText, authorText: t1, handleSubmit, edit: t2 } = t0;
    const authorText = void 0 === t1 ? "" : t1;
    const edit = void 0 === t2 ? false : t2;
    const [quote, setQuote] = useState(selectionText || "");
    const [author, setAuthor] = useState(authorText);
    const validator = useValidationService();
    let t3;
    if ($[0] !== quote) {
        t3 = {
            quote
        };
        $[0] = quote;
        $[1] = t3;
    } else t3 = $[1];
    const allValues = t3;
    let t4;
    if ($[2] !== validator) {
        t4 = validator.required("\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
        $[2] = validator;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== t4) {
        t5 = {
            quote: [
                t4
            ]
        };
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const fieldValidators = t5;
    const { errors, touched, validateField, hasValidationErrors, handleBlur } = useForm(allValues, fieldValidators);
    const validatorsByEditStatus = edit ? hasValidationErrors || authorText === author && selectionText === quote : hasValidationErrors;
    const headerTextByEditStatus = edit ? "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0446\u0438\u0442\u0430\u0442\u044B" : "\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0446\u0438\u0442\u0430\u0442\u044B";
    const buttonTextByEditStatus = edit ? "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" : "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C";
    let t6;
    if ($[6] !== validateField) {
        t6 = (value)=>_async_to_generator(function*() {
                setQuote(()=>value || "");
                yield validateField("quote", value);
            })();
        $[6] = validateField;
        $[7] = t6;
    } else t6 = $[7];
    const handleChangeQuoteInput = t6;
    let t7;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (value_0)=>{
            setAuthor(()=>value_0 || "");
        };
        $[8] = t7;
    } else t7 = $[8];
    const handleChangeAuthorInput = t7;
    let t8;
    if ($[9] !== author || $[10] !== editor || $[11] !== handleSubmit || $[12] !== onClose || $[13] !== quote || $[14] !== selectionText) {
        t8 = ()=>{
            if (handleSubmit) {
                handleSubmit(author, quote);
                onClose();
                return;
            }
            editor.update(()=>{
                const selection = $getSelection();
                if (!$isRangeSelection(selection)) {
                    const quoteNode = $createQuoteNode(quote, author);
                    const paragraphNode = $createParagraphNode();
                    $getRoot().append(quoteNode, paragraphNode);
                    paragraphNode.select();
                    onClose();
                    return;
                }
                const selectedNode = getSelectedNode(selection);
                const parentNode = selectedNode.getParent();
                let targetBlockNode = null;
                if ("reference-node" === selectedNode.getType() || "code-block-node" === selectedNode.getType()) targetBlockNode = selectedNode;
                else if ((null == parentNode ? void 0 : parentNode.getType()) === "reference-node" || (null == parentNode ? void 0 : parentNode.getType()) === "code-block-node") targetBlockNode = parentNode;
                if (targetBlockNode) {
                    const extractedText = selectionText || selection.getTextContent();
                    selection.insertText("");
                    const quoteNode_0 = $createQuoteNode(extractedText, author);
                    targetBlockNode.insertAfter(quoteNode_0);
                    const paragraphNode_0 = $createParagraphNode();
                    quoteNode_0.insertAfter(paragraphNode_0);
                    paragraphNode_0.select();
                    if ("" === targetBlockNode.getTextContent().trim()) targetBlockNode.remove();
                    onClose();
                    return;
                }
                const quoteText = selectionText || quote;
                const quoteNode_1 = $createQuoteNode(quoteText, author);
                const paragraphNode_1 = $createParagraphNode();
                selection.insertNodes([
                    quoteNode_1
                ]);
                quoteNode_1.insertAfter(paragraphNode_1);
                paragraphNode_1.select();
                onClose();
            });
        };
        $[9] = author;
        $[10] = editor;
        $[11] = handleSubmit;
        $[12] = onClose;
        $[13] = quote;
        $[14] = selectionText;
        $[15] = t8;
    } else t8 = $[15];
    const onSubmit = t8;
    let t9;
    if ($[16] !== onClose) {
        t9 = /*#__PURE__*/ jsx(Button, {
            size: "large",
            variant: "tertiaryLight",
            type: "button",
            onClick: onClose,
            children: "Отменить"
        });
        $[16] = onClose;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== buttonTextByEditStatus || $[19] !== validatorsByEditStatus) {
        t10 = /*#__PURE__*/ jsx(Button, {
            disabled: validatorsByEditStatus,
            size: "large",
            variant: "primary",
            type: "submit",
            children: buttonTextByEditStatus
        });
        $[18] = buttonTextByEditStatus;
        $[19] = validatorsByEditStatus;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== t10 || $[22] !== t9) {
        t11 = /*#__PURE__*/ jsxs(Fragment, {
            children: [
                t9,
                t10
            ]
        });
        $[21] = t10;
        $[22] = t9;
        $[23] = t11;
    } else t11 = $[23];
    const t12 = touched.quote && !!errors.quote;
    const t13 = touched.quote ? errors.quote : void 0;
    let t14;
    if ($[24] !== handleBlur) {
        t14 = handleBlur("quote");
        $[24] = handleBlur;
        $[25] = t14;
    } else t14 = $[25];
    let t15;
    if ($[26] !== handleChangeQuoteInput || $[27] !== quote || $[28] !== t12 || $[29] !== t13 || $[30] !== t14) {
        t15 = /*#__PURE__*/ jsx(TextInput, {
            label: "\u0426\u0438\u0442\u0430\u0442\u0430",
            required: true,
            placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0442\u0435\u043A\u0441\u0442",
            value: quote,
            onChange: handleChangeQuoteInput,
            name: "text",
            error: t12,
            helperText: t13,
            onBlur: t14
        });
        $[26] = handleChangeQuoteInput;
        $[27] = quote;
        $[28] = t12;
        $[29] = t13;
        $[30] = t14;
        $[31] = t15;
    } else t15 = $[31];
    let t16;
    if ($[32] !== author) {
        t16 = /*#__PURE__*/ jsx(TextInput, {
            label: "\u0410\u0432\u0442\u043E\u0440",
            placeholder: "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0430\u0432\u0442\u043E\u0440\u0430 \u0446\u0438\u0442\u0430\u0442\u044B",
            value: author,
            onChange: handleChangeAuthorInput,
            clearable: true,
            name: "link"
        });
        $[32] = author;
        $[33] = t16;
    } else t16 = $[33];
    let t17;
    if ($[34] !== headerTextByEditStatus || $[35] !== onClose || $[36] !== t11 || $[37] !== t15 || $[38] !== t16) {
        t17 = /*#__PURE__*/ jsxs(DialogContent, {
            title: headerTextByEditStatus,
            onClose: onClose,
            actions: t11,
            children: [
                t15,
                t16
            ]
        });
        $[34] = headerTextByEditStatus;
        $[35] = onClose;
        $[36] = t11;
        $[37] = t15;
        $[38] = t16;
        $[39] = t17;
    } else t17 = $[39];
    let t18;
    if ($[40] !== onSubmit || $[41] !== t17) {
        t18 = /*#__PURE__*/ jsx("form", {
            onSubmit: onSubmit,
            children: t17
        });
        $[40] = onSubmit;
        $[41] = t17;
        $[42] = t18;
    } else t18 = $[42];
    let t19;
    if ($[43] !== onClose || $[44] !== open || $[45] !== t18) {
        t19 = /*#__PURE__*/ jsx(Dialog, {
            open: open,
            onClose: onClose,
            children: t18
        });
        $[43] = onClose;
        $[44] = open;
        $[45] = t18;
        $[46] = t19;
    } else t19 = $[46];
    return t19;
};
export { QuoteDialog };
